import { findConstructorItemByCondition } from "../../../../lib/constructor/findConstructorItemByCondition.js";
import { instanceOfGrid } from "../../../../lib/grid/instanceOfGrid.js";
import "react";
import "@perxis-auto/shared/lib";
import "@perxis-auto/shared";
import "../../../../lib/constructor/mergeConstructor.js";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import "../../../../config/env.js";
import "../../../../config/events.js";
import { ConstructorWidgetEnum } from "../../../../types/constructor/widget.js";
import "../../../../lib/logger/index.js";
import "react-router";
import "@perxis-auto/shared/lib/lib/is/isObject";
import "../../../../lib/store/createAppApi.js";
import "../../../../lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../lib/store/createAppSelector.js";
import "../../../../lib/store/createAppSlice.js";
import "redux";
import "../../../../lib/store/hooks/useAppDispatch.js";
import "../../../../lib/store/hooks/useAppSelector.js";
import "../../../../lib/store/hooks/useAppStore.js";
import { selectPage } from "../../../installation/model/selectors/selectPage.js";
import { selectSlice } from "./selectSlice.js";
const selectFilterGrid = createAppSelector([selectSlice, selectPage], (config, page) => {
  if (!page.current || !config.layout) {
    return;
  }
  const filterGrid = findConstructorItemByCondition(
    config.layout[page.current],
    (e) => instanceOfGrid(e) && e.type === ConstructorWidgetEnum.FilterPanel
  );
  return filterGrid;
});
export {
  selectFilterGrid
};
